import { InjectionToken } from '@angular/core';
import { SlideShowService } from './service/slide-show.service';

// Lives here (not in pos-display.providers.ts) so the globals file can type its
// config without importing the providers file, which pulls in the routes graph.
export interface PosDisplayOptions {
  slideShowBackgroundColor: string;
  displaySlideshowAfter?: number; // delay time for setTimout in ms
}

export const SOFTLINE_CONFIG_WWS_POS_DISPLAY_CONFIG =
  new InjectionToken<PosDisplayOptions>('SOFTLINE_CONFIG_WWS_POS_DISPLAY_CONFIG', {
    providedIn: 'root',
    factory: () => ({ slideShowBackgroundColor: '#000000' }),
  });

export const SOFTLINE_CONST_WWS_POS_DISPLAY_CONFIG_KEY = 'pos-display/config';

// Remote-config (v1/app/config) module + property keys that drive the Kundendisplay.
export const SOFTLINE_REMOTE_CONFIG_MODULE_POS_DISPLAY = 'pos-display';
export const SOFTLINE_REMOTE_CONFIG_KEY_SHOW_PRICES = 'PREISE_ANZEIGEN';
export const SOFTLINE_REMOTE_CONFIG_KEY_SHOW_DISCOUNTS = 'RABATTE_ANZEIGEN';

export const SOFTLINE_TOKEN_WWS_POS_DISPLAY_SLIDE_SHOW_SERVICE =
  new InjectionToken<SlideShowService>(
    'SOFTLINE_TOKEN_WWS_POS_DISPLAY_SLIDE_SHOW_SERVICE'
  );
